import Vector from '@/components/Vector'
import Icon from '@/components/icons/icons.vue'
import Footer from '@/components/layout/footer.vue'
import PixelImg from '@/components/pixelImg'
import Table from '@/components/tables/tableContainer'
import Loader from '@/components/loader'
import Datepicker from 'vuejs-datepicker'
import {ptBR} from 'vuejs-datepicker/dist/locale'

const GlobalComponents = {
  install (Vue) {
    Vue.component('dr-vector', Vector)
    Vue.component('dr-icon', Icon)
    Vue.component('dr-footer', Footer)
    Vue.component('dr-pixel', PixelImg)
    Vue.component('dr-table', Table)
    Vue.component('dr-loader', Loader)
    Vue.component('dr-datepicker', {
      extends: Datepicker,
      props: {
        format: {default: 'D d/M/yy'},
        fullMonthName: {default: true},
        language: {
          default: function () {
            return ptBR
          }
        }
      }
    })
  }
}

export default GlobalComponents
